export enum ExceptionsSearchOptions {
    sku = "sku",
    store = "store",
  }
  
  export const ExceptionsSearchOptionsType = [
    { value: ExceptionsSearchOptions.sku, label: "SKU" },
    { value: ExceptionsSearchOptions.store, label: "Store" },
  ];